/* eslint-disable default-param-last */
import * as Cesium from "cesium";
import { Viewer as CesiumViewer } from "cesium";
import { create } from "zustand";
import { Model } from "../../../data/c4/modelings.data";

export type TilesetConfig = {
  path: string;
  adjustHeight?: number;
  splitDirection?: Cesium.SplitDirection;
  name?: string;
};

export type CameraPhase = {
  position: [number, number, number];
  orientation: {
    heading: number;
    pitch: number;
    roll: number;
  };
};

type ViewStatus = {
  viewer: CesiumViewer | null;
  phase: CameraPhase;
  setViewer: (viewer: CesiumViewer) => void;
  setPhase: (data: CameraPhase) => void;
  baseModel?: TilesetConfig;
  setBaseModel: (baseModel?: TilesetConfig) => void;
  models: Model[];
  setModels: (models: Model[]) => void;
};

const useViewerStore = create<ViewStatus>((set, get) => {
  return {
    viewer: null,
    phase: {
      position: [-3051522.38852034, 4040815.0796598564, 3865339.2794841235],
      orientation: {
        heading: 3.93971674518829,
        pitch: -0.23865777394028398,
        roll: 0.000008137311466427377,
      },
    },
    setPhase: (data) => {
      const { viewer } = get();

      if (viewer) {
        viewer.camera.flyTo({
          duration: 1,
          destination: new Cesium.Cartesian3(...data.position),
          orientation: data.orientation,
        });
      }
      // set({ phase: data });
    },
    setViewer: (viewer) => {
      if (viewer) {
        viewer.camera.flyTo({
          duration: 1,
          destination: new Cesium.Cartesian3(...get().phase.position),
          orientation: get().phase.orientation,
        });
      }
      set({ viewer });
    },
    baseModel: undefined,
    setBaseModel: (baseModel) => {
      set({ baseModel });
    },
    models: [],
    setModels: (models) => {
      set({ models });
    },
  };
});

export default useViewerStore;
